import React, { useState, useRef } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner, Input } from "reactstrap";
import Select2 from "react-select2-wrapper";
import "select2/dist/css/select2.min.css";
import { useTranslation } from "context/TranslationProvider";
import { useNotification } from "providers/NotificationProvider";
import helpers from "utils/helpers";

const DeactivateReasonModal = ({ isOpen, toggle, onConfirm }) => {
  const { t } = useTranslation();
  const { notify } = useNotification();
  const modalBodyRef = useRef(null);

  const [reason, setReason] = useState("");
  const [comments, setComments] = useState("");
  const [loading, setLoading] = useState(false);

  const options = [
    { id: "", text: t("page.users.selectReason", "Select reason") },
    ...helpers.getDeactivateUserReasons(t),
  ];

  const handleSubmit = async () => {
    if (!reason) {
      return notify("error", t("page.users.enterReason", "Please select a reason"));
    }

    setLoading(true);
    try {
      await onConfirm(comments, reason);
      setReason("");
      setComments("");
    } catch (err) {
      console.error(err);
      notify("error", t("page.users.toast.unexpectedError", "Something went wrong"));
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (loading) return;
    setReason("");
    setComments("");
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} size="md" className="modal-dialog-centered">
      <ModalHeader toggle={handleClose} className="border">
        {t("page.users.deactivateReason", "Deactivate User")}
      </ModalHeader>

      <ModalBody ref={modalBodyRef}>
        <Select2
          className="form-control"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          options={{
            width: "100%",
            dropdownParent: modalBodyRef.current,
            data: options,
          }}
        />

        <div className="mt-3">
          <Input
            type="textarea"
            rows={3}
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            placeholder={t("page.users.additionalComments", "Additional comments (optional)")}
            disabled={loading}
          />
        </div>
      </ModalBody>

      <ModalFooter className="border">
        <Button color="secondary" onClick={handleClose} disabled={loading}>
          {t("common.cancel", "Cancel")}
        </Button>
        <Button color="danger" onClick={handleSubmit} disabled={loading || !reason}>
          {loading ? (
            <>
              <Spinner size="sm" className="mr-2" />
              {t("page.users.common.deactivate", "Deactivate")}
            </>
          ) : (t("page.users.common.deactivate", "Deactivate"))}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeactivateReasonModal;
